import React, { useEffect, useState } from 'react';
import { Container, Card, Row, Col } from 'react-bootstrap';
import colorPaletteOutline from '../images/color-palette-outline.svg';
import colorPaletteGreyOutline from '../images/color-palette-grey.svg'
import blurimg from '../images/blur.svg'
import dotsimg from '../images/dots.svg'
import dotssquareimg from '../images/dots-square.svg'
import HowWeDoSection from '../page-sections/how-we-do-section';
import axios from 'axios';
import FaqSection from '../page-sections/faq-section';

function ContactUs() {

    const [successmsg, setSuccessmsg] = useState("");
    const [errormsg, setErrormsg] = useState("");
    const [selectedclass, setSelectedclass] = useState("custom-select border-0 bg-transparent form_fields lh-46");

    const email_validation = (email) => {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    };

    const name_validation = (name) => {
        var letters = /^([\s\.]?[a-zA-Z]+)+$/;
        if (name.match(letters)) {
            return true;
        }
        else {
            return false;
        }
    };

    const mobile_number_validation = (mobile) => {
        var phoneno = /^\d{10}$/;
        if (mobile.match(phoneno)) {
            return true;
        }
        else {
            return false;
        }
    };

    const set_error = (fieldid) => {
        //var div_error = $('#'+fieldid).closest('div[class^="input-group"]');
        //div_error.addClass('has-error');
    };

    const alertmsg = (message, focusid) => {
        setErrormsg(message);
        if (focusid && focusid !== "") {
            document.getElementById(focusid).focus();
        }
    };

    const successmsgfn = (message) => {
        setSuccessmsg(message);
    };

    const serviceValidate = async (event) => {
        var service = document.getElementById('service').value;
        var classname = "custom-select border-0 bg-transparent form_fields lh-46";
        if (service && service !== "") {
            classname = classname + " selected";
        }
        setSelectedclass(classname);
    };

    const getQuote = async (event) => {
        event.preventDefault();

        setErrormsg("");
        setSuccessmsg("");

        var name = document.getElementById('name').value;
        var email = document.getElementById('email').value;
        var service = document.getElementById('service').value;
        var budget = document.getElementById('budget').value;
        var message = document.getElementById('message').value;

        var name_val = name_validation(name);
        var email_val = email_validation(email);

        //has error validation
        if (!name || name === "") {
            set_error("name");
        }
        if (!name_val) {
            set_error("name");
        }
        if (!email || email === "") {
            set_error("email");
        }
        if (!email_val) {
            set_error("email");
        }
        if (!service || service === "") {
            set_error("service");
        }
        if (!budget || budget === "") {
            set_error("budget");
        }
        if (!message || message === "") {
            set_error("message");
        }

        if (!name || name === "") {
            alertmsg("Name is required", "name");
        }
        else if (!name_val) {
            alertmsg("Type valid name", "name");
        }
        else if (!email || email === "") {
            alertmsg("Email id is required", "email");
        }
        else if (!email_val) {
            alertmsg("Type valid email id", "email");
        }
        else if (!service || service === "") {
            alertmsg("Service is required", "service");
        }
        else if (!budget || budget === "") {
            alertmsg("Budget is required", "budget");
        }
        else if (!message || message === "") {
            alertmsg("Message is required", "message");
        }
        else {
            const apiBase = process.env.REACT_APP_API_URL || "";
            var site_url = apiBase + "/veeyaaapi?work=getquote&name=" + encodeURIComponent(name) + "&email=" + encodeURIComponent(email) + "&service=" + encodeURIComponent(service) + "&budget=" + encodeURIComponent(budget) + "&message=" + encodeURIComponent(message);
            axios.get(site_url)
                .then(res => {
                    const table_data = res.data;
                    var response = table_data[0].response;
                    var reason = table_data[0].reason;
                    if (response === "success") {
                        successmsgfn("Quote sent successfully,We will contact you shortly");
                        document.getElementById("quoteForm").reset();
                        var classname = "custom-select border-0 bg-transparent form_fields lh-46";
                        setSelectedclass(classname);
                    }
                    else {
                        alertmsg(reason, "");
                    }
                })
                .catch(() => {
                    alertmsg("Unable to send quote. Please try again or contact us directly at admin@veeyaainnovatives.com", "");
                });
        }
    };

    return (
        <>


            <div id="home">
                <div className="cover-img contact-cover position-relative h-40vh">



                    {/* Design */}
                    <div className="d-flex pattern-img contact-pattern">

                    </div>


                    <div className="overlays glass">
                        {/* h-41rem */}
                        <Container fluid className="py-5">
                            <Row className="h-100 mt-3">
                                <Col md={10} className="mx-auto">
                                    <Row className="h-100">
                                        <Col md={12} lg={12} className="d-flex">
                                            <div className="text-white mt-5">
                                                {/* <span className="text-uppercase fs12  sub-title">We are Veeyaa Innovatives</span> */}
                                                <h1 className='page-title mt-4 red'>Want to build  <br /> something Awesome!</h1>





                                                {/* <button className="btn btn-cards br-20px  px-4">Contact Us</button> */}
                                            </div>
                                        </Col>

                                    </Row>
                                </Col>
                            </Row>
                        </Container>


                    </div>
                </div>
            </div>

            <Container>
                <div className="bg-white border-0 pb-0 pt-3 px-4 mt-5">
                    <h1 className=" font-title op-9 mb-1 pt-2">Contact Us</h1>
                    <p className="color-grey3  d-block">We will reach you in notime</p>
                </div>
                <Row>

                    <Col md={12} lg={7}>

                        <Card className="bg-white border-0 w-100 ">
                            <Card.Header className="bg-white border-0 pb-0 pt-3 px-4">
                                {/* <h1 className=" font-title op-9 mb-1 pt-2">Contact Us</h1>
                                <p className="color-grey3  d-block">We will reach you in notime</p> */}
                            </Card.Header>
                            <Card.Body className="px-4 pb-4 pt-3 ">

                                <form className="custom-input" onSubmit={getQuote} id="quoteForm">
                                    <div className="input-group floating-input mb-3">
                                        <input type="text" id="name" className="form-control border-0 bg-transparent pt-0 form_fields" placeholder=" " />
                                        <label className="floating-lable d-block position-absolute px-2 pt-0 bg-white">Name</label>
                                    </div>
                                    <div className="input-group floating-input mb-3">
                                        <input type="text" id="email" className="form-control border-0 bg-transparent pt-0 form_fields" placeholder=" " />
                                        <label className="floating-lable d-block position-absolute px-2 pt-0 bg-white">Email</label>
                                    </div>
                                    <div className="input-group floating-input mb-3">
                                        <select className={selectedclass} onChange={serviceValidate} id="service">
                                            <option value=""></option>
                                            <option value="Mobile App Development">Mobile App Development</option>
                                            <option value="Website Development">Website Development</option>
                                            <option value="Shopping Website">Shopping Website</option>
                                            <option value="Inventory Management system">Inventory Management system</option>
                                        </select>
                                        <label className="floating-lable d-block position-absolute px-2 pt-0 bg-white">Service you need</label>
                                    </div>
                                    <div className="input-group floating-input mb-3">
                                        <input type="number" id="budget" className="form-control border-0 bg-transparent pt-0 form_fields" placeholder=" " />
                                        <label className="floating-lable d-block position-absolute px-2 pt-0 bg-white">Your budget</label>
                                    </div>
                                    <div className="input-group floating-input textarea-form-input mb-3 h-auto">
                                        <textarea id="message" className="form-control border-0 bg-transparent  form_fields" rows="3" placeholder=" " />
                                        <label className="floating-lable d-block position-absolute px-2 pt-0 bg-white">Message</label>
                                    </div>

                                    <div className="fs14 mb-3 text-center">
                                        <span className="text-danger">{errormsg}</span>
                                        <span className="text-success">{successmsg}</span>
                                    </div>

                                    <Row className="text-center mt-4">
                                        <Col md={{ span: 4, offset: 4 }}>
                                            <button type="submit" className="btn btn-quote btn-block py-2">
                                                Send
                                            </button>
                                        </Col>
                                    </Row>
                                </form>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col md={12} lg={5}>
                        <div className="mt-5 ps-lg-3">
                            {/* Location Card */}
                            <Card className="bg-white border-0 mb-4 shadow-sm contact-info-card box-shadow-none">
                                <Card.Body className="px-lg-0 d-flex align-items-start">
                                    <div className="contact-icon mr-3">
                                        <span className="lnr lnr-map-marker"></span>
                                    </div>
                                    <div className="contact-content">
                                        <h4 className="font-title mb-3 op-9">Our Location</h4>
                                        <p className="color-grey3 mb-2">Thiruvottiyur, Chennai-600019</p>
                                        <p className="color-grey3 mb-0">Tamil Nadu, India</p>
                                        <p className="color-grey3 mt-3 fs14 contact-info-italic">Serving clients globally with digital solutions</p>
                                    </div>
                                </Card.Body>
                            </Card>

                            {/* Email Card */}
                            <Card className="bg-white border-0 shadow-sm contact-info-card box-shadow-none">
                                <Card.Body className="px-lg-0 d-flex align-items-start">
                                    <div className="contact-icon mr-3">
                                        <span className="lnr lnr-envelope"></span>
                                    </div>
                                    <div className="contact-content">
                                        <h4 className="font-title mb-3 op-9">Email Us</h4>
                                        <p className="color-grey3 mb-3">admin@veeyaainnovatives.com</p>
                                        <p className="color-grey3 mb-0 fs14 contact-info-italic">We'll respond within 24 hours</p>
                                    </div>
                                </Card.Body>
                            </Card>
                        </div>
                    </Col>

                </Row>

                 {/* Why Choose Veeyaa Innovatives Section */}
                   <div className="mt-5 pt-5">
                       <div className="text-center mb-5">
                           <div className="position-relative section-title">
                               <h1 className="fs28 title">Why Choose Veeyaa Innovatives?</h1>
                               <span className="mirror-text">Why Choose Us</span>
                           </div>
                       </div>
                       <Row>
                           <Col md={12}>
                               <Row>
                                   <Col md={6} lg={4}>
                                       <Card className="service-cards mb-4">
                                           <Card.Body>
                                               <div className="icon purple">
                                                   <span className="fas fa-bolt"></span>
                                               </div>
                                               <h2 className="fs22 mt-4">Fast Delivery</h2>
                                               <p className="desc">
                                                   Quick turnaround times without compromising on quality. We understand the importance of meeting deadlines.
                                               </p>
                                           </Card.Body>
                                       </Card>
                                   </Col>
                                   <Col md={6} lg={4}>
                                       <Card className="service-cards mb-4">
                                           <Card.Body>
                                               <div className="icon blue">
                                                   <span className="fas fa-brain"></span>
                                               </div>
                                               <h2 className="fs22 mt-4">Expert Development</h2>
                                               <p className="desc">
                                                   Experienced developers with expertise in multiple technologies and frameworks. We stay updated with the latest trends.
                                               </p>
                                           </Card.Body>
                                       </Card>
                                   </Col>
                                   <Col md={6} lg={4}>
                                       <Card className="service-cards mb-4">
                                           <Card.Body>
                                               <div className="icon green">
                                                   <span className="fas fa-headset"></span>
                                               </div>
                                               <h2 className="fs22 mt-4">24/7 Support</h2>
                                               <p className="desc">
                                                   Round-the-clock support for your projects. We're always here to help with any questions or concerns.
                                               </p>
                                           </Card.Body>
                                       </Card>
                                   </Col>
                               </Row>
                           </Col>
                       </Row>
                   </div>

<FaqSection />
            </Container>







        </ >
    );
}

export default ContactUs;
